export default {
  defaultProps: {
    spacing: 4,
  },
}
